import { Box, SxProps, Theme } from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import { tokenFadeIn } from '@rhg/utils/animations';
import { StreamingTokenProps } from './types';

const styleToken = (
    isVisible: boolean,
    animationDurationMs: number
): SxProps<Theme> => ({
    display: 'inline',
    opacity: isVisible ? 1 : 0,
    animation: isVisible
        ? `${tokenFadeIn} ${animationDurationMs}ms cubic-bezier(0.4, 0, 0.2, 1) forwards`
        : 'none',
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        opacity: isVisible ? 1 : 0,
    },
});

const styleSpace: SxProps<Theme> = {
    display: 'inline',
};

export function StreamingToken({
    content,
    isVisible,
    isNewline,
    animationDurationMs,
    sx,
}: StreamingTokenProps) {
    if (isNewline) {
        return isVisible ? <br /> : null;
    }

    if (!isVisible) {
        return null;
    }

    return (
        <>
            <Box
                component="span"
                sx={sxAppend(styleToken(isVisible, animationDurationMs), sx)}
            >
                {content}
            </Box>
            <Box component="span" sx={styleSpace}>
                {' '}
            </Box>
        </>
    );
}
